export default class Captcha {
  constructor() {
    this.recaptcha = document.getElementById('g-recaptcha');
    this.redirectUrl = sessionStorage.getItem('redirect-url');

    if (this.recaptcha && this.redirectUrl) {
      // Redirect user to specified page on sucess
      const captchaForm = document.querySelector('.shopify-challenge__container form');
      const submitCaptcha = captchaForm.querySelector('input[type="submit"]');
      const input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', 'return_to');
      input.setAttribute('value', this.redirectUrl);

      captchaForm.insertBefore(input, submitCaptcha);

      // Clear session
      sessionStorage.removeItem('redirect-url');
    }
  }
}
